import React from "react";


const Loader = () => {

    return (
        <div className="component-box">
            <div className="inline-box loader-box">
                <div className="loader"></div>
                <span className="loading-msg">OSイメージ ファイルを確認中</span>
            </div>


        </div>

    );
};

export default Loader;